import throttle from "lodash/throttle";
import { getElementNaturalHeight, getBreakpointIndex } from "../utils";

function openMenu(menu, links) {
  let timeline = new gsap.timeline({ paused: true });

  let currentDimensions = menu.getBoundingClientRect();
  let newHeight = getElementNaturalHeight(links);

  timeline.fromTo(
    menu,
    {
      opacity: 1,
      height: currentDimensions.height,
    },
    {
      height: newHeight,
      opacity: 1,
      duration: 0.3,
      ease: "Power0.easeNone",
    }
  );

  timeline.play();

  return timeline;
}

/**
 * resizeMenu
 * @param {*} menu
 * @param {*} onComplete
 * @param {*} submenu
 */
function increaseMenuSize(menu, onComplete, submenu) {
  let timeline = new gsap.timeline({ paused: true });

  let currentDimensions = menu.getBoundingClientRect();
  let submenuHeight = getElementNaturalHeight(submenu, {
    parentNode: menu,
  });

  timeline.to(menu, {
    height: currentDimensions.height + submenuHeight,
    duration: 0.3,
    ease: "Power0.easeNone",
    onComplete: onComplete,
  });

  timeline.play();

  return timeline;
}

function reduceMenuSize(menu, onComplete, submenu) {
  let timeline = new gsap.timeline({ paused: true });

  let currentDimensions = menu.getBoundingClientRect();
  let submenuHeight = getElementNaturalHeight(submenu, {
    parentNode: menu,
  });

  timeline.to(menu, {
    height: currentDimensions.height - submenuHeight,
    duration: 0.3,
    ease: "Power0.easeNone",
    onComplete: onComplete,
  });

  timeline.play();

  return timeline;
}

/**
 * animateOut
 * @param {*} submenu
 */
function animateOut(submenu, onComplete) {
  let timeline = new gsap.timeline({ paused: true });
  timeline.to(submenu, {
    height: "0px",
    opacity: 1,
    onComplete: onComplete,
  });
  timeline.play();
  return timeline;
}

/**
 * MobileMenu
 * Manages the toggle of the mobile menu
 */
export const MobileMenu = (menu) => {
  let toggle = document.querySelector("#mobile-menu-toggle");
  let wrapper = menu.querySelector(".menu--main--links-wrapper");
  let menuLinks = menu.querySelector(".menu--main--links-inner");
  let breakpointIndex = getBreakpointIndex();
  let state = {
    isDesktop: breakpointIndex >= 3 ? true : false,
  };
  let timeline = new gsap.timeline({ paused: true });
  const eventMenuTransition = document.createEvent("Event");
  eventMenuTransition.initEvent("menu_transition", true, true);

  /**
   * assertIfClickOutside
   * @param {*} event
   */
  // const assertIfClickOutside = (event) => {
  //   if (
  //     !menu.contains(event.target) &&
  //     menuLinks.classList.contains("active")
  //   ) {
  //     close();
  //   }
  // };

  const throttledResize = throttle(() => {
    breakpointIndex = getBreakpointIndex();
    if (state.isDesktop === false && breakpointIndex >= 3) {
      // move from mobile to desktop
      state.isDesktop = true;
      document.dispatchEvent(eventMenuTransition);
      close();
    } else if (state.isDesktop === true && breakpointIndex < 3) {
      // move from desktop to mobile
      state.isDesktop = false;
      document.dispatchEvent(eventMenuTransition);
    }
  }, 200);

  window.addEventListener("resize", throttledResize);

  // Listen for the event.
  document.addEventListener(
    "submenu_open",
    (event) => {
      increaseMenuSize(wrapper, () => {}, event.target);
    },
    false
  );

  document.addEventListener(
    "submenu_close",
    (event) => {
      reduceMenuSize(wrapper, () => {}, event.target);
    },
    false
  );

  /**
   * open
   */
  const open = () => {
    menuLinks.classList.add("active");
    document.querySelector(".main-header").classList.add("nav-active");

    timeline = openMenu(wrapper, menuLinks);

    // window.addEventListener("click", assertIfClickOutside);
  };

  /**
   * close
   */
  const close = () => {
    menuLinks.classList.remove("active");
    document.querySelector(".main-header").classList.remove("nav-active");
    timeline = animateOut(wrapper, () => {}, menu);
    // window.removeEventListener("click", assertIfClickOutside);
  };

  // event binding
  if (toggle) {
    toggle.addEventListener("click", () => {
      menuLinks.classList.contains("active") ? close() : open();
    });
  }
};
